import PropTypes from 'prop-types';

const formatNumber = (value) => value.toLocaleString('de-DE');

export default function EnrichmentCostHint({ companyCount, maxContacts, heldContacts = 0, availableCredits }) {
	const maxCredits = Math.max(0, companyCount * maxContacts - heldContacts);
	const exceedsBalance = availableCredits !== null && maxCredits > availableCredits;

	return (
		<div className="min-w-0 text-xs text-bgBase-800">
			<p className="text-sm text-text">
				Max. <strong>{formatNumber(maxCredits)} Kontakt-Credits</strong>
				{availableCredits !== null && (
					<span className={exceedsBalance ? 'text-caution-700' : ''}>
						{' '}
						· verfügbar {formatNumber(availableCredits)}
					</span>
				)}
			</p>
			<p>
				{formatNumber(companyCount)} Firmen × {maxContacts}
				{heldContacts > 0 && ` abzüglich ${formatNumber(heldContacts)} bereits vorhandene`}; abgerechnet werden
				nur neu gefundene Ansprechpartner.
			</p>
			{exceedsBalance && (
				<p className="text-caution-700">
					Das Guthaben reicht für höchstens {formatNumber(availableCredits)} Ansprechpartner, danach stoppt
					die Anreicherung.
				</p>
			)}
		</div>
	);
}

EnrichmentCostHint.propTypes = {
	companyCount: PropTypes.number.isRequired,
	maxContacts: PropTypes.number.isRequired,
	/** Contacts the companies already hold, capped per company at maxContacts — they cannot be billed again. */
	heldContacts: PropTypes.number,
	availableCredits: PropTypes.number,
};
